<template>
  <div>
    <b-card class="surrounding-card" :style="backgroundStyle">
      <b-card no-body class="mb-1" style="border-radius: 16px 16px 16px 16px;">
        <b-card-header><h5 class="my-auto">Notices</h5></b-card-header>
        <div class="p-4" style="min-width: 55rem; min-height: 30rem;">
          <div v-for="notice in data" class="mb-3" :key='notice.id' :style="'border-radius: 6px 6px 6px 6px; background-color: ' + applyNoticeColour(notice.color) + '; color: ' + applyNoticeTextColour(notice.color)">
            <span class="px-2">&#x2022;&nbsp;&nbsp;{{notice.content}}<span v-if="notice.startDate != null"> - {{$options.filters.dateFormat(new Date(notice.startDate), "dddd, MMM D YYYY")}}</span></span>
          </div>
        </div>
      </b-card>
    </b-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { productColor } from '../../helpers/functions';

export default {
  name: 'Notices',
  props: {
    account: {
      type: Object
    },        
  },
  data () {
    return {
        data: {}
    }
  },
  computed: {
    ...mapGetters({
      subscription: "plan/getSubscription"
    }),
    backgroundStyle() {
      if (this.subscription && this.subscription.product && this.subscription.product.productid) {
        const color = productColor(this.subscription.product.productid);
        return `background: linear-gradient(to right top, #5f135f 35%, ${color} 55%); border-radius: 16px 16px 16px 16px; background-origin: border-box;`;
      } else if (this.account && this.account.flexiplan && this.account.flexiplan.product && this.account.flexiplan.product.productid) {
        const color = productColor(this.account.flexiplan.product.productid);
        return `background: linear-gradient(to right top, #5f135f 35%, ${color} 55%); border-radius: 16px 16px 16px 16px; background-origin: border-box;`;
      }
      return `background: linear-gradient(to right top, #5f135f 35%, #471747 52%); border-radius: 16px 16px 16px 16px; background-origin: border-box;`;
    }
  },
  methods: {
    applyNoticeColour(color) {
      return color != null ? '#'+color : 'lightgrey'
    },
    applyNoticeTextColour(color) {
      return color != null ? 'white' : 'black'
    }
  },
  created: function() {
    this.$portalapi.get('/open/site/notices')
      .then(response => {
        this.data = response.data
        this.$log.onDebug(JSON.stringify(this.data))
      })

  }
}
</script>

<style lang="scss" scoped>

  .surrounding-card {
    border-radius: 16px 16px 16px 16px;
    box-shadow: 28px 24px 12px 6px grey;
    border: none;
  }

  .card-header:first-child {
    border-radius: 2rem 2rem 0 0;
  }

</style>